export default {
  // 获取购物车头部数量
  getCartCount: {
    url: '/mall/product/getShoppingCartCount',
    type: 'post'
  }
}
